import { ReactNode } from 'react';

import classes from 'components/common/Tables/Cells/TitleAndSubTitle/TitleAndSubTitle.module.scss';

interface Props {
    title: string | ReactNode;
    subTitle: string;
    disabled?: boolean;
}

export const TitleAndSubTitle = ({ title, subTitle, disabled }: Props) => {
    return (
        <div className={classes.titlesComponent}>
            <span className={`${classes.title} ${disabled ? classes.disabled : ''}`}>{title}</span>
            <span className={classes.subTitle}>{subTitle}</span>
        </div>
    );
};
